module.exports = __webpack_public_path__ + "img/1603.10ebefad.png";